// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NQHh","content":"styles_content__32VWI"};